"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const locations = [{
  id: "hq",
  city: "Charmhaven",
  country: "Australia",
  address: "9 Norah Ave, Charmhaven NSW 2263",
  top: "78%",
  left: "88%",
  timezone: "Australia/Sydney",
  isHQ: true
}];
export default function GlobalReach() {
  const [mounted, setMounted] = useState(false);
  const [currentTime, setCurrentTime] = useState<Date>(new Date());
  useEffect(() => {
    setMounted(true);
    const timer = setInterval(() => setCurrentTime(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);
  const getLocalTime = (timeZone: string) => {
    if (!mounted) return "--:--";
    try {
      return new Intl.DateTimeFormat("en-US", {
        timeStyle: "short",
        timeZone
      }).format(currentTime);
    } catch (e) {
      return "--:--";
    }
  };
  return <section data-section-id="224599" id="global-reach" className="w-full py-24 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16 space-y-4">
          <h2 className="text-3xl md:text-5xl font-bold font-default tracking-tighter">
            Global Reach, Local Impact
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl font-default">
            Future Mind Consulting operates at the intersection of global innovation and local expertise. Visit our headquarters or connect with our strategic advisors.
          </p>
        </div>

        <div className="relative w-full max-w-6xl mx-auto aspect-square md:aspect-[21/9] bg-zinc-950 rounded-3xl overflow-hidden shadow-4xl border border-border/20">
          {}
          <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688832/img/consulting_world_network.png)] bg-cover bg-center opacity-30 mix-blend-screen pointer-events-none"></div>

          {}
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#1fb6ff12_1px,transparent_1px),linear-gradient(to_bottom,#1fb6ff12_1px,transparent_1px)] bg-[size:32px_32px] pointer-events-none"></div>

          {}
          {locations.map((loc, i) => <div key={loc.id} data-index={i} className="absolute z-10" style={{
          top: loc.top,
          left: loc.left,
          transform: "translate(-50%, -50%)"
        }}>
              <Popover>
                <PopoverTrigger asChild>
                  <Button variant="ghost" size="icon" className="relative h-auto w-auto p-0 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-950 group" aria-label={`View details for ${loc.city} office`}>
                    {}
                    <span className="absolute inline-flex h-8 w-8 rounded-md bg-primary opacity-40 group-hover:opacity-60 animate-ping"></span>
                    {}
                    <span className="relative inline-flex rounded-md h-4 w-4 bg-primary ring-2 ring-primary/30 transition-transform group-hover:scale-110"></span>
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-72 bg-card/80 backdrop-blur-2xl border-border/40 shadow-4xl p-0 overflow-hidden" sideOffset={8}>
                  <div className="p-4 border-b border-border/40 bg-muted/20">
                    <div className="flex items-center justify-between mb-1">
                      <h3 className="font-default font-bold text-lg flex items-center gap-2 text-foreground">
                        {loc.city}
                        {loc.isHQ && <span className="text-[10px] uppercase tracking-widest bg-primary/20 text-primary px-2 py-0.5 rounded-sm font-mono">
                            HQ
                          </span>}
                      </h3>
                      <div className="flex items-center text-primary text-xs font-mono font-semibold bg-primary/10 px-2 py-1 rounded-sm">
                        <span suppressHydrationWarning>
                          {getLocalTime(loc.timezone)}
                        </span>
                      </div>
                    </div>
                    <p className="text-xs text-muted-foreground font-mono uppercase tracking-wider">
                      {loc.country}
                    </p>
                  </div>
                  <div className="p-4 space-y-3">
                    <div className="flex items-start text-sm">
                      <span className="text-foreground/90 font-default leading-tight">
                        {loc.address}
                      </span>
                    </div>
                    <div className="flex items-start text-sm">
                      <span className="text-foreground/90 font-default leading-tight">
                        FMC Innovation Hub
                      </span>
                    </div>
                    <Button variant="link" className="p-0 h-auto text-primary text-xs font-mono uppercase tracking-widest hover:no-underline group">
                      Get Directions
                      <ArrowRight className="w-3 h-3 ml-1 transition-transform group-hover:translate-x-1" />
                    </Button>
                  </div>
                </PopoverContent>
              </Popover>
            </div>)}
        </div>

        <div className="mt-12 flex justify-center">
          <Button asChild size="lg" className="rounded-md px-10 bg-primary text-primary-foreground hover:shadow-[0_0_20px_rgba(0,255,255,0.4)] transition-all duration-300">
            <Link to="/ConnectPage">
              Book a Consultation
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}